import { Helmet } from 'react-helmet';
import CaseStudies from '../components/CaseStudies';

export default function CaseStudiesPage() {
  return (
    <>
      <Helmet>
        <title>Case Studies | The Prisu Experts</title>
        <meta
          name="description"
          content="See how The Prisu Experts has delivered scalable AI data solutions for global clients through real-world case studies."
        />
      </Helmet>
      <CaseStudies />
    </>
  );
}
